import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { arrayUtils } from '@olameter/o-utilities';
import {
  FSRWOCountRequestModel,
  TeamWOCountModel,
  TeamWOCountRequestModel,
  TerritoryModel,
  UserWOCountModel,
} from '../../../CommonFiles/BusinessModels';
import { WorkOrderActionsGRPCService } from '../../../ProxyServices/workorderactions.grpc.service';
import { map } from 'rxjs';
import { TerritoryUser } from '../../../proto/generated/Territory_message_pb';
import { MapProperties } from '../../../CommonFiles/enums/workOrderDetails.enum';
import { FsrCountModel, TeamCountModel } from '../../../CommonFiles/UIModels';
@Component({
  standalone: false,
  selector: 'app-legend-control',
  templateUrl: './legend-control.component.html',
  styleUrls: ['./legend-control.component.scss'],
})
export class LegendControlComponent implements OnInit {
  userList: FsrCountModel[];
  teamList: TeamCountModel[];
  @Input() contractName: string;
  userTerritoryList: TerritoryUser[] = [];
  territoryList: TerritoryModel[] = [];

  @Input() public set fsrNamesOnMap(fsrNames: Array<object>) {
    if (fsrNames) {
      this._client.getTerritory(this.contractName)
        .pipe(
          map((x) => {
            this.territoryList = x;
            this.territoryList.forEach((ter) => {
              ter.usersList.forEach((user) => {
                this.userTerritoryList.push(user);
              });
            });
            this.getFsrWoCount(fsrNames);
          })
        )
        .subscribe();
    }
  }

  @Input() public set teamsOnMap(teams: Array<object>) {
    if (teams) {
      this.getTeamWoCount(teams);
    }
  }

  constructor(
    private _client: WorkOrderActionsGRPCService, 
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  private getFsrWoCount(listUResourceN: Array<object>) {
    this.userList = [];
    let fsrNames = listUResourceN.map((f) => {
      return f[MapProperties.FsrName]
    });

    let fsrcountmodel: FSRWOCountRequestModel = new FSRWOCountRequestModel();
    fsrcountmodel.contractID = this.contractName;
    fsrcountmodel.FSRList = fsrNames;
    fsrcountmodel.activeOnly = true;
    this._client.getFSRWOCount(fsrcountmodel).subscribe((listCount) => {
      if (listCount?.length > 0) {
        let usr: FsrCountModel[] = [];
        const grouped = arrayUtils.groupBy(
          listCount,
          (lc: UserWOCountModel) => lc.name
        );
        listUResourceN.forEach((userResourceName) => {
          const groupedUser = grouped.get(userResourceName[MapProperties.FsrName]) as UserWOCountModel[];
          const userCount = groupedUser != null
            ? groupedUser.reduce((previousValue: number, currentWO: UserWOCountModel) => previousValue + currentWO.count, 0)
            : 0;

          usr.push({
            name: userResourceName[MapProperties.FsrName],
            count: userCount,
            icon_colour: userResourceName[MapProperties.FsrColour],
          });
        });

        let op = usr.map((e) => {
          let temp = this.userTerritoryList.find(element => element.getName() === e.name);
          if (temp) {
            e.user_name = temp.getUserName();
          }
          return e;
        });
        this.userList = op;
        this.ref.markForCheck();
      }
    });
  }

  private getTeamWoCount(teams: Array<object>){
    this.teamList = [];

    var teamIds = teams.map((f) => {
      return f[MapProperties.TeamId]
    });

    var teamcountmodel: TeamWOCountRequestModel = new TeamWOCountRequestModel();
    teamcountmodel.contractID = this.contractName;
    teamcountmodel.TeamList = teamIds;
    teamcountmodel.activeOnly = true;

    this._client.getTeamWOCount(teamcountmodel).subscribe((listCount) =>{
      if (listCount?.length > 0){
        var team: TeamCountModel[] = [];

        const grouped = arrayUtils.groupBy(
          listCount,
          (lc: TeamWOCountModel) => lc.teamId
        );

        teams.forEach((teamResourceId) => {
          var teamId = teamResourceId[MapProperties.TeamId];
          var groupedTeam = grouped.get(teamId) as TeamWOCountModel[];

          if(groupedTeam != null){
            var teamCount = groupedTeam.reduce((previousValue: number, currentWO: TeamWOCountModel) => previousValue + currentWO.count, 0);

            var t = listCount.find(x => x.teamId == teamId);
  
            team.push({
              team_title: t.teamTitle,
              count: teamCount,
              icon_colour: teams.find(x => x[MapProperties.TeamId] == teamId)[MapProperties.TeamColour],
              techs: t.techs
            });
          }          
        });

        this.teamList = team;
        this.ref.markForCheck();
      }
    });
  }
}